import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { CurrencyItem } from '@/models/dictionary/currency-list.model';
import { AvailableCurrencyListRequestModel } from '@/models/currency/currency.model';

export default class GetAvailableCurrencyListRequest extends ApiResourceMethod<CurrencyItem[]> {
  public perform(params: AvailableCurrencyListRequestModel): Promise<CurrencyItem[]> {
    return this.performer.requestWithMapper(
      { params },
      (payload: BaseResponse<CurrencyItem[]>) => {
        return payload.data;
      },
    );
  }
}
